export function getGoogleAnalyticsMeasurementId(): string | null {
  const measurementId =
    process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID?.trim() ||
    process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS_ID?.trim() ||
    "";

  return measurementId || null;
}

export function getClarityProjectId(): string | null {
  const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID?.trim() || "";

  return projectId || null;
}
